<template>
    <div class="d-block text-justify">
	</div>
</template>
<script>
	export default {
		name: "payments",
		components: {
		},
		props: {
			legal_name: null,
			project_id: {default: null}
		},
	};
</script>